import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { getCurrentUserNotifications } from "./schema/get-current-user-notifications";
import { markNotificationRead } from "./schema/mark-notification-read";

export const rpcDefinition = {
  getCurrentUserNotifications,
  markNotificationRead,
};

export type RedoMerchantNotificationsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
